export const defaultFontColor = '#ffffff';
export const defaultBgColor = '#afafaf';
export const defaultCircleBgColor = '#b7b7b7';
export const defaultCircleBorderColor = '#000000';
